import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=4ef6bc08&"
import script from "./ListItem.vue?vue&type=script&lang=js&"
export * from "./ListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports